// Generated by GitHub Copilot
import React from "react";
import PropTypes from "prop-types";
import { FaExclamationTriangle, FaInfoCircle } from "react-icons/fa";
import { capitalize } from "../../../utils/textFormatters";
import styles from "./PrivilegeToggle.module.css";

/**
 * Privilege Toggle Component with risk indicators and descriptions
 */
const PrivilegeToggle = ({
  privilege,
  enabled,
  onChange,
  disabled = false,
}) => {

  /**
   * Get risk icon based on risk level
   */
  const getRiskIcon = (riskLevel) => {
    if (riskLevel === "high") {
      return <FaExclamationTriangle className={styles.badgeIcon} />;
    }
    return <FaInfoCircle className={styles.badgeIcon} />;
  };

  /**
   * Handle toggle change
   */
  const handleChange = (event) => {
    onChange(privilege.name, event.target.checked);
  };

  return (
    <div
      className={`${styles.toggleContainer} ${
        disabled ? styles.disabled : ""
      }`}
    >
      <div className={styles.toggleSwitch}>
        <input
          type="checkbox"
          id={`privilege-${privilege.name}`}
          checked={enabled}
          onChange={handleChange}
          disabled={disabled}
        />
      </div>

      <div className={styles.toggleContent}>
        <div className={styles.toggleHeader}>
          <div className={styles.toggleTitle}>{privilege.displayName}</div>
          <span
            className={`${styles.badge} ${
              styles[`badge${capitalize(privilege.riskLevel)}`]
            }`}
          >
            {getRiskIcon(privilege.riskLevel)}
            {capitalize(privilege.riskLevel)}
          </span>
        </div>

        <div className={styles.toggleDescription}>{privilege.description}</div>

        {privilege.dependencies && privilege.dependencies.length > 0 && (
          <div className={styles.dependenciesText}>
            Requires: {privilege.dependencies.join(", ")}
          </div>
        )}
      </div>

      {disabled && (
        <div className={styles.restrictionText}>
          {privilege.name === "deity" ? "Deity only" : "Restricted"}
        </div>
      )}
    </div>
  );
};

PrivilegeToggle.propTypes = {
  privilege: PropTypes.shape({
    name: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    riskLevel: PropTypes.string.isRequired
  }).isRequired,
  enabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default PrivilegeToggle;
